/**
 * Browser-safe binding of the shared filters in `./filters.ts`, supplying the
 * two pieces that cannot cross the runtime boundary: `crypto-js` hashing,
 * because the browser cannot resolve Node's built-in crypto, and plain `Error`
 * subclasses, because the SDK's come from `apollo-server-express`, which would
 * pull Express into the bundle. These carry no apollo semantics — just a
 * `.message` the UI can surface.
 */
import {
  createCommonFilters,
  cryptoJsHash,
  type CommonFilters,
} from "./filters";

class UserInputError extends Error {}
class ValidationError extends Error {}

// Frontend engines MUST register via these keys, never
// `engine.registerFilter(fn.name, fn)`: the app ships a minified bundle where
// `Function.name` is mangled, so a name-based loop binds every filter wrong —
// silently no-opping it under `strictFilters: false`. String-literal keys
// survive. The backend runs unminified, so `commonFunctions` is unaffected.
export const commonFiltersByName: CommonFilters = createCommonFilters({
  hash: cryptoJsHash,
  UserInputError,
  ValidationError,
});

export const {
  sha256,
  sha512,
  md5,
  json_construct,
  to_date,
  to_unix,
  remove_key,
  array_construct,
} = commonFiltersByName;

export const commonFunctions = Object.values(commonFiltersByName);
